import { Module } from 'vuex'

import { RootState } from '../types'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import { AppState } from './types'

export const app: Module<AppState, RootState> = {
  namespaced: true,
  state: {
    data: {
      searchParams: {
        word: '',
        specialtyTypes: [],
        featureTypes: []
      }
    }
  },
  getters,
  actions,
  mutations
}
